import palette from './palette';

const familyTitle = 'Roboto';
const familyText = 'Roboto';

export default {
  h1: {
    fontFamily: familyTitle,
    fontStyle: 'normal',
    color: palette.white,
    fontWeight: 900,
    fontSize: 45,
    letterSpacing: 0,
  },
  h2: {
    fontFamily: familyTitle,
    fontStyle: 'normal',
    color: palette.white,
    fontWeight: 900,
    fontSize: 32,
    letterSpacing: 0,
  },
  h3: {
    color: palette.mediumGray,
    fontWeight: 300,
    fontFamily: familyTitle,
    fontStyle: 'normal',
    fontSize: 30,
    letterSpacing: '0px',
    lineHeight: '30px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
    lineHeight: '24px',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  subtitle1: {
    fontFamily: familyText,
    color: palette.black,
    fontSize: 14,
    letterSpacing: 0,
    lineHeight: '25px',
  },
  subtitle2: {
    fontFamily: familyText,
    color: palette.mainGray,
    fontSize: 12,
    letterSpacing: 0,
    lineHeight: '21px',
  },
  body1: {
    fontFamily: familyText,
    color: palette.gray,
    fontSize: 16,
    letterSpacing: 0,
  },
  body2: {
    fontFamily: familyText,
    color: palette.text.secondary,
    fontSize: 14,
    letterSpacing: '-0.04px',
    lineHeight: '18px',
  },
  button: {
    fontFamily: familyText,
    fontWeight: 300,
    color: palette.primary.light,
    textDecoration: 'none',
    fontSize: 16,
    letterSpacing: 0,
    lineHeight: 1.5,
    textTransform: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  caption: {
    color: palette.text.secondary,
    fontSize: 12,
    letterSpacing: '0.33px',
    lineHeight: '13px',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};
